import React from 'react';
import CandidateSearch from '../components/CandidateSearch/CandidateSearch';
import Navbar from '../components/Navbar';

const CandidateSearchPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <CandidateSearch />
    </div>
  );
};

export default CandidateSearchPage;
